var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
var SimpleDialog = function (props) {
    var t = useTranslation().t;
    // Only Dialog props go through: the others would land on the DOM, the title as a native hover tooltip
    var title = props.title, message = props.message, onConfirm = props.onConfirm, onCancel = props.onCancel, confirmText = props.confirmText, cancelText = props.cancelText, icon = props.icon, dialogProps = __rest(props, ["title", "message", "onConfirm", "onCancel", "confirmText", "cancelText", "icon"]);
    return (_jsxs(Dialog, __assign({}, dialogProps, { open: props.open, onClose: props.onClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" }, { children: [!!props.icon &&
                _jsxs(Box, __assign({ sx: {
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        marginTop: '25px'
                    } }, { children: [" ", props.icon, " "] })), props.title &&
                _jsx(DialogTitle, __assign({ id: "alert-dialog-title" }, { children: props.title })), props.message &&
                _jsx(DialogContent, { children: _jsx(DialogContentText, __assign({ id: "alert-dialog-description" }, { children: props.message })) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: function () {
                            if (props.onCancel) {
                                props.onCancel();
                            }
                            else {
                                if (!props.onClose)
                                    return null;
                                props.onClose('_', 'backdropClick');
                            }
                        } }, { children: !!props.cancelText ? props.cancelText : t('Close') })), _jsxs(Button, __assign({ variant: 'contained', onClick: function () {
                            if (!props.onConfirm)
                                return null;
                            props.onConfirm();
                        } }, { children: [" ", !!props.confirmText ? props.confirmText : t('Confirm')] }))] })] })));
};
export default SimpleDialog;
